import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import * as Enumerable from 'linq';

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {

    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {

        // const title = this.buildTitle(snapshot) // get deepest title
        const title = this.getRouteDataTitle(snapshot.root);

        this.title.setTitle(
            title
                ? `${title} | Workbuddy`
                : `Workbuddy`
        )
    }

    /** For old title define, combine to tree */
    private getRouteDataTitle(route: ActivatedRouteSnapshot): string {

        const titleArray = [];

        while (route!.firstChild) {
            route = route.firstChild;

            const title = route.title ?? route.data['title'];

            if (title) {
                titleArray.unshift(title)
            }
        }

        const routeTitle = Enumerable.from(titleArray)
            .where(x => !!x)
            .where((x, i) => x !== titleArray[i - 1]) // avoid duplicate adjacent, eg: Public | Assets | Assets | Workbuddy
            .toJoinedString(' | ');

        return routeTitle
    }

}